import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import DatePicker from 'react-datepicker';
import { useSettingContext } from '@context/SettingContent';
import { format } from 'date-fns';
import style from '../calender.module.scss';
import CalenderInput from '../CalenderInput';

function PLDatePicker({ value, placeholder, inputIcon, onSelected }) {
  const {
    setting: { countryDateFormat },
  } = useSettingContext();
  const [selectedDate, setSelectedDate] = useState(null);

  function handleDateChange(date) {
    const formattedDate = format(new Date(date), 'yyyy-MM-dd');
    setSelectedDate(date);
    onSelected(formattedDate);
  }

  useEffect(() => {
    if (value) {
      setSelectedDate(new Date(value));
    }
  }, [value]);

  return (
    <div className={style.calenderContainer}>
      <DatePicker
        selected={selectedDate}
        onChange={date => handleDateChange(date)}
        startDate={selectedDate}
        minDate={new Date()}
        dateFormat={countryDateFormat}
        popperPlacement="top-end"
        customInput={<CalenderInput placeholderText={placeholder} value={value} icon={inputIcon} />}
      />
    </div>
  );
}

PLDatePicker.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  placeholder: PropTypes.string,
  inputIcon: PropTypes.string,
  onSelected: PropTypes.func,
};

export default PLDatePicker;
